"use strict";

const t = "complementary-products",
      e = "data-url",
      n = "data-slider";

class s extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        new IntersectionObserver(((s, r) => {
            s[0].isIntersecting && (
                r.unobserve(this),
                this.hasAttribute(e) && "" !== this.getAttribute(e) &&
                fetch(this.getAttribute(e))
                    .then((t) => t.text())
                    .then((e) => {
                        const tempContainer = document.createElement("div");
                        tempContainer.innerHTML = e;
                        const complementaryBlock = tempContainer.querySelector(t);
                        
                        if (complementaryBlock && complementaryBlock.innerHTML.trim().length) {
                            this.innerHTML = complementaryBlock.innerHTML;
                            this.hasAttribute(n) && this.dispatchEvent(new CustomEvent("theme:complementary:loaded", {
                                bubbles: true,
                                detail: { container: this }
                            }));
                        } else {
                            // Hide the section and remove any existing titles
                            this.style.display = "none";
                            this.innerHTML = "";

                            // Check for any external complementary products title and remove it
                            const title = document.querySelector(".complementary-products__title");
                            if (title) {
                                title.remove();
                            }
                        }
                    })
                    .catch((t) => {
                        console.error(t);
                    })
            );
        }).bind(this), { rootMargin: "0px 0px 400px 0px" }).observe(this);
    }
}

// Register the custom element if it's not already defined
if (!customElements.get("complementary-products")) {
    customElements.define("complementary-products", s);
}
